import Select from "react-select";
import tools from "utils/tools";

const emptyRow = () => ({
  id: undefined,
  title: "",
  days: "",
  guaranteeCompanyId: null,
  status: true,
});

const Guarantee = ({ form, setForm, guaranteeCompanies }) => {
  const rows: any[] = form?.guarantees || [];

  const companyOptions = guaranteeCompanies.map((c) => ({
    value: c.id,
    label: c.title,
  }));

  const update = (index: number, field: string, value: any) => {
    setForm((prev) => {
      const next = [...(prev.guarantees || [])];
      next[index] = { ...next[index], [field]: value };
      return { ...prev, guarantees: next };
    });
  };

  const add = () => {
    setForm((prev) => ({
      ...prev,
      guarantees: [...(prev.guarantees || []), emptyRow()],
    }));
  };

  const remove = (index: number) => {
    setForm((prev) => {
      const next = [...(prev.guarantees || [])];
      next.splice(index, 1);
      return { ...prev, guarantees: next };
    });
  };

  return (
    <div className="AddInfoContainer">
      {rows.map((row, index) => (
        <section
          key={index}
          className={`addProductInfo ${index % 2 !== 0 ? "backGround" : ""}`}
        >
          <div className="selectorContainer">
            <span className="input3">
              <label className="sideBarTitle">شرکت گارانتی</label>
              <Select
                options={companyOptions}
                value={companyOptions.find((o) => o.value === row.guaranteeCompanyId) || null}
                placeholder="انتخاب کنید"
                onChange={(sel) => update(index, "guaranteeCompanyId", sel?.value ?? null)}
                className="selector1"
              />
            </span>
            <span className="input3">
              <label className="sideBarTitle">عنوان</label>
              <input
                className="selector1"
                value={row.title}
                onChange={(e) => update(index, "title", e.target.value)}
              />
            </span>
            <span className="input3">
              <label className="sideBarTitle">مدت (روز)</label>
              <input
                className="selector1"
                type="number"
                value={row.days}
                onChange={(e) => update(index, "days", Number(e.target.value))}
              />
            </span>
            <span className="input3">
              <label className="sideBarTitle">وضعیت</label>
              <select
                className="selector1"
                value={row.status ? 1 : 0}
                onChange={(e) => update(index, "status", Number(e.target.value) === 1)}
              >
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>
            </span>
            <span className="input3" style={{ display: "flex", alignItems: "flex-end" }}>
              <button
                className="dashboardHeader"
                style={{ background: "#e53e3e" }}
                onClick={() => remove(index)}
              >
                <p>حذف</p>
              </button>
            </span>
          </div>
        </section>
      ))}
      <button className="dashboardHeader" style={{ marginTop: 16 }} onClick={add}>
        <p>+ افزودن گارانتی</p>
      </button>
    </div>
  );
};

export default Guarantee;
